export default __webpack_public_path__ + "static/media/ic_reuse.d8fe102d.svg";